module.exports = __webpack_public_path__ + "media/images/social-icons/link-white-0ca32d48d63d2e4ff81e23a90f7cc428.svg";